import { SHOW_CONFIRM_TAGS } from "../content/site";

export function SwordMark({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 48" className={className} aria-hidden="true" fill="currentColor">
      <circle cx="12" cy="3" r="2.4" />
      <rect x="10.8" y="5" width="2.4" height="7" />
      <rect x="3" y="12" width="18" height="2.6" />
      <path d="M10 14.6h4V40l-2 6-2-6z" />
    </svg>
  );
}

export function ConfirmTag({ testId, label = "Pending leadership confirmation" }) {
  if (!SHOW_CONFIRM_TAGS) return null;
  return (
    <span
      data-testid={testId}
      className="inline-flex w-fit items-center gap-2 border border-dashed border-[#B9AFB2]/40 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#B9AFB2]"
    >
      <span className="h-1.5 w-1.5 bg-[#B8324E]" aria-hidden="true" />
      {label}
    </span>
  );
}

export function Marquee({ items, testId = "motto-marquee", className = "" }) {
  const row = [...items, ...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-[#F6F2F0]/10 bg-[#090909] py-6 sm:py-8 ${className}`} data-testid={testId}>
      <div className="marquee-track" aria-hidden="true">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`font-display text-4xl font-semibold uppercase tracking-tight sm:text-6xl lg:text-7xl ${i % 2 ? "outline-text" : "text-[#F6F2F0]"}`}>
                  {t}
                </span>
                <SwordMark className="mx-6 h-8 w-4 text-[#B8324E] sm:mx-10 sm:h-12 sm:w-6" />
              </span>
            ))}
          </div>
        ))}
      </div>
      <p className="sr-only">{items.join(" ")}</p>
    </div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`eyebrow flex items-center gap-3 ${className}`}>
      <span className="h-px w-8 bg-[#B8324E]" aria-hidden="true" />
      {children}
    </p>
  );
}
